import Vue from "vue";
import { NavigationGuard } from "vue-router";
import { WaitKeys } from "@/helpers/WaitKeys";
import { RouteNames } from "@/router";
import { msalInstance } from "@/services";
import { store } from "@/store";

export const authGuard: NavigationGuard = async (to, from, next) => {
    Vue.nextTick(async () => {
        store.dispatch("wait/start", WaitKeys.login);

        // Login with Azure AD
        const loggedIn = await msalInstance.login();
        if (!loggedIn) {
            return next({ name: RouteNames.unauthorized });
        }

        // Load user account
        await store.dispatch("account/loadAccount");
        if (!store.getters["account/isAuthenticated"]) {
            return next({ name: RouteNames.unauthorized });
        }

        if (!store.getters["account/user"]) {
            await store.dispatch("account/loadUser");
        }

        const isUserRegistered = store.getters["account/isRegistered"];
        if (!isUserRegistered && to.name !== RouteNames.unauthorized) {
            return next({ name: RouteNames.unauthorized });
        }
        else if (isUserRegistered && (to.name === RouteNames.unauthorized)) {
            return next({ name: RouteNames.home });
        }

        store.dispatch("wait/end", WaitKeys.login);

        return next();
    });
};
